export const isFreeEmailDomain = (email: string, emailDomains: string[] = []): boolean => {
    if (!email) return false;
    const lowerEmail = email.toLowerCase();

    const domain = lowerEmail.split('@')[1];

    return emailDomains.includes(domain);
};

export const PHONE_ALLOWED_CHARS_REGEX = /^\+?[0-9\s\-()]+$/;

export const countPhoneDigits = (value?: string) => {
    return (value ?? '').replace(/\D/g, '').length;
};

export const validatePhoneNumber = (value?: string, required = false): Promise<void> => {
    const raw = (value ?? '').trim();

    if (!raw) {
        if (required) {
            return Promise.reject(new Error('Phone is required.'));
        }
        return Promise.resolve();
    }

    if (!PHONE_ALLOWED_CHARS_REGEX.test(raw)) {
        return Promise.reject(
            new Error('Please enter a valid phone number.')
        );
    }

    const digitCount = countPhoneDigits(raw);

    if (digitCount < 7 || digitCount > 18) {
        return Promise.reject(
            new Error('Phone number must contain between 7 and 18 digits.')
        );
    }

    return Promise.resolve();
};

// for promise-based validation
export const isPhoneNumberValid = (value?: string, required = false): boolean => {
    const raw = (value ?? '').trim();

    if (!raw) return !required;
    if (!/^\+?[0-9\s\-()]+$/.test(raw)) return false;

    const digitCount = (raw.match(/\d/g) ?? []).length;
    return digitCount >= 7 && digitCount <= 18;
};